import { render, staticRenderFns } from "./learningRecordForm.vue?vue&type=template&id=2786e482&scoped=true&"
import script from "./learningRecordForm.vue?vue&type=script&lang=ts&"
export * from "./learningRecordForm.vue?vue&type=script&lang=ts&"
import style0 from "./learningRecordForm.vue?vue&type=style&index=0&id=2786e482&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2786e482",
  null
  
)

export default component.exports